import fetcher from "@/utils/fetcher";

export const GET_RESULT = async (query, options = {}) => {
  // Check if streaming is requested
  const isStream = options.stream === true;
  
  if (isStream) {
    // Return a promise that will resolve with the event source and data
    return new Promise((resolve, reject) => {
      const events = [];
      const url = new URL(`${window.location.origin}/api/query${query}`);
      url.searchParams.append('stream', 'true');
      
      const eventSource = new EventSource(url.toString());
      
      // Setup event handlers
      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          events.push(data);
          
          // If callback is provided, call it with each new data
          if (typeof options.onMessage === 'function') {
            options.onMessage(data);
          }
        } catch (error) {
          console.error('Error parsing SSE data:', error);
        }
      };
      
      eventSource.onerror = (error) => {
        eventSource.close();
        if (typeof options.onError === 'function') {
          options.onError(error);
        }
        reject(error);
      };
      
      // Handle the "done" event to close the connection
      eventSource.addEventListener('done', () => {
        eventSource.close();
        if (typeof options.onComplete === 'function') {
          options.onComplete(events);
        }
        resolve(events);
      });
      
      // Handle error events
      eventSource.addEventListener('error', (event) => {
        eventSource.close();
        const errorData = JSON.parse(event.data);
        if (typeof options.onError === 'function') {
          options.onError(errorData);
        }
        reject(errorData);
      });
      
      // Allow manual abort
      if (options.signal) {
        options.signal.addEventListener('abort', () => {
          eventSource.close();
          reject(new DOMException('Aborted', 'AbortError'));
        });
      }
    });
  } else {
    // Use regular fetch for non-streaming requests
    return await fetcher({
      url: `/query${query}`,
      method: "GET",
    });
  }
};

export const GET_INFO = async () => {
  return await fetcher({
    url: `/regions`,
    method: "GET",
  });
};
